import React from 'react';
import { ProductDetail } from '../components';
import { M131ProductDetailModule } from '~/lib/data-contract';
import { ModuleFeatureContext } from '~/templates/blocks/context/ModuleFeatureContext';

export type M131Props = M131ProductDetailModule;

export const M131ProductDetail = (props: M131Props) => {
    return (
        <ModuleFeatureContext.Provider value={{ reserveInStore: true }}>
            <ProductDetail {...props} />
        </ModuleFeatureContext.Provider>
    );
};
